module.exports = __webpack_public_path__ + "static/media/08 Tenor Saxophone Region 20 Scales.3b31c7c6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/08 Tenor Saxophone Region 20 Scales.pdf
// module id = 268
// module chunks = 0